"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconLockCrossed = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconLockCrossed = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "m20.148 17.29-2.15-2.15V9.997h-5.142l-2.15-2.15h4.242v-2c0-.856-.302-1.587-.907-2.192a2.984 2.984 0 0 0-2.191-.908c-.79 0-1.505.294-2.146.88-.641.587-.962 1.327-.962 2.22v.03l-1.748-1.8c.325-1.008.932-1.84 1.823-2.496A4.983 4.983 0 0 1 11.85.597c1.455 0 2.694.51 3.715 1.526 1.022 1.018 1.533 2.26 1.533 3.724v2h3.05v9.443Zm.375 6.282-1.225-1.225H3.648V8.128h1.43L.374 3.422l1.529-1.528 20.15 20.15-1.529 1.528Zm-3.375-3.375-3.673-3.673-3.02-3.019-3.507-3.508h-1.15v10.2h11.35Z"
}));
exports.IconLockCrossed = IconLockCrossed;
//# sourceMappingURL=IconLockCrossed.js.map